// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1OUnZ","bigColWidth":"Table_bigColWidth__1EuRE","biggerColWidth":"Table_biggerColWidth__3NxnC","row":"Table_row__NvnSl","col":"Table_col__P98Xc"};